import { OnInit, EventEmitter, ElementRef } from '@angular/core';
var PanelComponent = /** @class */ (function () {
    function PanelComponent(element) {
        this.element = element;
        this._open = false;
        this.showActionsOnHover = false;
        this.canToggle = true;
        this.isCompact = false;
        this.opened = new EventEmitter();
    }
    Object.defineProperty(PanelComponent.prototype, "open", {
        get: function () {
            return this._open;
        },
        set: function (value) {
            this._open = value;
        },
        enumerable: true,
        configurable: true
    });
    PanelComponent.prototype.ngOnInit = function () {
    };
    PanelComponent.prototype.handleClickHeader = function () {
        if (!this.canToggle) {
            return;
        }
        this.togglePanel();
        // Only emit opened event when triggered by user. We do this so the application can react
        // specifically to user input, without interference from programatic changes of the opened
        // state.
        this.opened.emit(this.open);
    };
    PanelComponent.prototype.togglePanel = function () {
        if (!this.canToggle) {
            return;
        }
        this.open = !this.open;
    };
    return PanelComponent;
}());
export { PanelComponent };
